import React from 'react';
import { LanguageToggle } from './LanguageToggle';
export const Layout = ({
  children
}: {
  children: ReactNode;
}) => {
  return <div className="min-h-screen bg-cream flex justify-center w-full" data-id="element-21">
      <div className="w-full max-w-md bg-cream min-h-screen shadow-2xl shadow-espresso/5 relative overflow-hidden flex flex-col" data-id="element-22">
        <LanguageToggle data-id="element-23" />
        {children}
      </div>
    </div>;
};